// #tag: POST-AUTHENTICATION NAVIGATION RESOLVER
// #purpose: Computes the destination route after successful sign-in based on user roles and requested return path.
import { canAccessAdmin, usesAdminConsoleOnly } from './adminAccess';

export function getPostLoginPath(from?: string, role?: string | null) {
  if (from && from !== '/login' && from !== '/register') {
    if (usesAdminConsoleOnly(role) && !from.startsWith('/admin')) {
      return '/admin';
    }
    return from;
  }
  if (usesAdminConsoleOnly(role)) return '/admin';
  if (canAccessAdmin(role)) return '/admin';
  return '/dashboard';
}
